import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';
import { createAdminAPI } from './api';
import { ERROR, INIT, LOADING, SUCCESS } from '../../utils/constants';

export const ANNUL_ADMIN_ERROR = 'advaice/create-admin/ANNUL_ADMIN_ERROR';

export const CHANGE_MODAL_STATUS = 'advaice/create-admin/CHANGE_MODAL_STATUS';

export const REGISTRATION_ADMIN = 'advaice/registration/REGISTRATION_ADMIN';
export const REGISTRATION_ADMIN_SUCCESS = 'advaice/registration/REGISTRATION_ADMIN_SUCCESS';
export const REGISTRATION_ADMIN_ERROR = 'advaice/registration/REGISTRATION_ADMIN_ERROR';

const initialState = {
  status: INIT,
  createModalStatus: false,
  adminsFullStatus: INIT,
  error: '',
};

export const createAdminStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case CHANGE_MODAL_STATUS: {
      return {
        ...state,
        createModalStatus: !state.createModalStatus,
      };
    }
    case REGISTRATION_ADMIN:
    {
      return {
        ...state,
        status: LOADING,
      };
    }
    case REGISTRATION_ADMIN_SUCCESS:
    {
      return {
        ...state,
        status: SUCCESS,
      };
    }
    case REGISTRATION_ADMIN_ERROR:
    {
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    }
    case ANNUL_ADMIN_ERROR:
    {
      return {
        ...state,
        status: INIT,
        error: '',
      };
    }
    default: {
      return state;
    }
  }
};

/* eslint-disable eol-last */
export const updateCreateAdminModal = () => ({ type: CHANGE_MODAL_STATUS });
export const annulAdminError = () => ({ type: ANNUL_ADMIN_ERROR });
export const createAdminUser = data => ({ type: REGISTRATION_ADMIN, payload: data });

export const createAdminObservable = (store, requestData) => Observable
  .fromPromise(createAdminAPI(requestData))
  .map(({ data }) => ({ type: REGISTRATION_ADMIN_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: REGISTRATION_ADMIN_ERROR, payload: err }));

export const createAdminEpic = (action$, store) => action$
  .ofType(REGISTRATION_ADMIN)
  .flatMap(action => createAdminObservable(store, action.payload));

export const createAdminsEpic = combineEpics(createAdminEpic);


// WEBPACK FOOTER //
// ./src/reducers/create-admin/duck.js